<header id="fixed-header" [class.menu-open]="menuOpen">
  <div class="wrapper">
    <div class="outer-container">
      <div class="inner-container">
        <div class="content-header">
          <div class="myunichoices-logo">
            <a (click)="goToHome()">
              <img src="assets/images/myunichoices-logo-desktop.png" alt="" />
            </a>
          </div>
          <app-main-account-links></app-main-account-links>
        </div>
      </div>
    </div>
  </div>
</header>

<app-main-nav></app-main-nav>

<div id="container" [class.menu-open]="menuOpen">
  <div class="wrapper">
    <div class="outer-container">
      <div class="inner-container" [ngClass]="{ 'centre-content': centreComponent }">
        <router-outlet></router-outlet>
        <div style="height: 70px;"></div>
      </div>
    </div>
  </div>
</div>

<footer id="fixed-footer" [class.menu-open]="menuOpen" *ngIf="showFooter">
  <div class="wrapper">
    <div class="outer-container">
      <div class="inner-container">
        <div class="continue-bn">
          <div [ngClass]="alignLeft ? 'prev-page-button' : 'next-page-button'">
            <div class="input-button" *ngIf="actionIsPath && !externalLink">
              <button [routerLink]="action" class="proceed">{{ title }}</button>
            </div>
            <div class="input-button" *ngIf="!actionIsPath && !externalLink">
              <button (click)="action()" class="proceed">{{ title }}</button>
            </div>
            <div class="input-button" *ngIf="externalLink">
              <button (click)="goToLink(action)" class="proceed">{{ title }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>



// WEBPACK FOOTER //
// ./src/app/components/_shared/main-layout/main-layout.component.html